import { render, staticRenderFns } from "./NormalDashboard.vue?vue&type=template&id=79ac3a83&scoped=true"
import script from "./NormalDashboard.vue?vue&type=script&lang=js"
export * from "./NormalDashboard.vue?vue&type=script&lang=js"
import style0 from "./NormalDashboard.vue?vue&type=style&index=0&id=79ac3a83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ac3a83",
  null
  
)

export default component.exports